import { Box } from "@mui/material";

import { EmailType } from "@interfaces/campaign.type";

import ReviewCampaign from "@pages/CreateCampaign/components/EditReviewAndTest/ReviewCampaign";
import SendingOptions from "@pages/CreateCampaign/components/EditReviewAndTest/SendingOptions";

import theme from "@theme/index";

interface ICampaignReviewProperties {
  campaignEmails: EmailType[];
  sendTestEmail: (email: string) => Promise<void>;
  showAuthenticateEmail: () => void;
}

export default function EditReviewAndTest({
  campaignEmails,
  sendTestEmail,
  showAuthenticateEmail,
}: ICampaignReviewProperties) {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        gap: 4,
        height: "100%",
        justifyContent: "center",
        overflow: "hidden",
        pb: 3,
        pt: 1,
        width: "100%",
      }}
    >
      <ReviewCampaign
        campaignEmails={campaignEmails}
        sendTestEmail={sendTestEmail}
        showAuthenticateEmail={showAuthenticateEmail}
      />

      <Box
        sx={{
          backgroundColor: theme.palette.borderColor.dark,
          height: "100%",
          margin: "0 16px",
          width: "1px",
        }}
      />

      <SendingOptions />
    </Box>
  );
}
